/* SSi website – Japanese landing page hero. Mirrors SpanishHero.jsx — same A/B variants. */
import { Link } from 'react-router-dom';

export function JapaneseHero({ onStart, t }) {
  const variant = t.jaHeroVariant || 'A';
  return variant === 'B'
    ? <JapaneseHeroB onStart={onStart} t={t}/>
    : <JapaneseHeroA onStart={onStart} t={t}/>;
}

function JapaneseHeroA({ onStart, t }) {
  return (
    <section className="ssi-jaHero ssi-jaHero--A" style={jaHeroStyles.wrapA}>
      <div className="ssi-jaHero__leftA" style={jaHeroStyles.leftA}>
        {t.jaHeroKicker && <div style={jaHeroStyles.kicker}>{t.jaHeroKicker}</div>}
        <h1 style={jaHeroStyles.h1}>{t.jaHeroTitle}</h1>
        <p style={jaHeroStyles.lede}>{t.jaHeroSub1}</p>
        <p style={jaHeroStyles.lede}>{t.jaHeroSub2}</p>
        <div style={jaHeroStyles.ctas}>
          <Link to="/pay?course=en-ja" className="btn btn--onDark">{t.jaHeroCta1}</Link>
          <a href="#sample" className="btn" style={jaHeroStyles.ghost}>{t.jaHeroCta2}</a>
        </div>
        <p style={jaHeroStyles.trust}>{t.jaHeroTrust}</p>
      </div>
      <div className="ssi-jaHero__rightA" style={jaHeroStyles.rightA}>
        <img src="/assets/hero_man_waving.png?v=6" alt="" style={jaHeroStyles.heroImg}/>
        <div className="ssi-jaHero__bubble" style={jaHeroStyles.bubble} aria-hidden>
          <span style={jaHeroStyles.bubbleWord}>{t.jaHeroBubble || "こんにちは!"}</span>
          <span style={jaHeroStyles.bubbleTail}/>
        </div>
      </div>
    </section>
  );
}

function JapaneseHeroB({ onStart, t }) {
  return (
    <section className="ssi-jaHero ssi-jaHero--B" style={jaHeroStyles.wrapB}>
      <div className="ssi-jaHero__innerB" style={jaHeroStyles.innerB}>
        <div className="ssi-jaHero__giantWrap" style={jaHeroStyles.giantWrap}>
          <span style={jaHeroStyles.giantTranslate}>(verb) to speak — hanasu</span>
          <div style={jaHeroStyles.giant} aria-hidden>{t.jaHeroGiantWord}</div>
          <div style={jaHeroStyles.giantUnderline}/>
        </div>
        <div style={jaHeroStyles.copyB}>
          {t.jaHeroKicker && <div style={jaHeroStyles.kickerB}>{t.jaHeroKicker}</div>}
          <h1 style={jaHeroStyles.h1B}>{t.jaHeroTitle}</h1>
          <p style={jaHeroStyles.ledeB}>{t.jaHeroSub1}</p>
          <p style={jaHeroStyles.ledeB}>{t.jaHeroSub2}</p>
          <div style={jaHeroStyles.ctas}>
            <Link to="/pay?course=en-ja" className="btn btn--onDark">{t.jaHeroCta1}</Link>
            <a href="#sample" className="btn" style={jaHeroStyles.ghost}>{t.jaHeroCta2}</a>
          </div>
          <p style={jaHeroStyles.trustB}>{t.jaHeroTrust}</p>
        </div>
      </div>
    </section>
  );
}

const jaHeroStyles = {
  kicker: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 18 },
  h1: { fontFamily: 'var(--font-display)', fontSize: 64, lineHeight: 1.04, color: '#fff', letterSpacing: '-.015em', margin: '0 0 20px', textWrap: 'balance' },
  lede: { fontSize: 18, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 18px', maxWidth: 540 },
  ctas: { display: 'flex', gap: 12, marginTop: 20, marginBottom: 24 },
  ghost: { background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,.5)' },
  trust: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
  wrapA: { background: 'var(--brandRed)', color: '#fff', padding: '88px 0 88px', position: 'relative', overflow: 'hidden', minHeight: 560 },
  leftA: { maxWidth: 600, padding: '0 32px', position: 'relative', zIndex: 2 },
  rightA: { position: 'absolute', right: '-320px', top: 0, bottom: 0, width: '50%', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', overflow: 'visible' },
  heroImg: { height: '100%', width: 'auto', objectFit: 'contain', objectPosition: 'right bottom' },
  bubble: { position: 'absolute', right: 'calc(58% + 60px)', top: 'calc(37% + 30px)', background: "#FFD84D", color: '#490300', padding: '18px 28px 22px', borderRadius: 18, transform: 'rotate(-5deg)', boxShadow: '0 18px 40px -14px rgba(0,0,0,.35), 0 2px 0 rgba(0,0,0,.08)', zIndex: 3 },
  bubbleWord: { fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 52, lineHeight: 1, letterSpacing: '-.02em', display: 'inline-block', fontStyle: 'italic' },
  bubbleTail: { position: 'absolute', right: 36, top: -12, width: 22, height: 22, background: "#FFD84D", borderTopLeftRadius: 4, transform: 'rotate(45deg)' },
  wrapB: { background: 'var(--brandRed)', color: '#fff', padding: '80px 0 88px', position: 'relative', overflow: 'hidden' },
  innerB: { maxWidth: 1240, margin: '0 auto', padding: '0 32px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'center' },
  giantWrap: { position: 'relative' },
  giantTranslate: { display: 'inline-block', fontSize: 13, color: 'rgba(255,255,255,.7)', letterSpacing: '.02em', fontStyle: 'italic', marginBottom: 4, marginLeft: 4 },
  giant: { fontFamily: 'var(--font-display)', fontSize: 'clamp(96px, 13vw, 200px)', lineHeight: .95, fontWeight: 700, letterSpacing: '-.03em', color: '#fff', margin: 0 },
  giantUnderline: { width: 80, height: 4, background: '#FFD84D', borderRadius: 4, marginTop: 20, marginLeft: 4 },
  copyB: { maxWidth: 520 },
  kickerB: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 16 },
  h1B: { fontFamily: 'var(--font-display)', fontSize: 44, lineHeight: 1.1, color: '#fff', letterSpacing: '-.015em', margin: '0 0 18px', textWrap: 'balance' },
  ledeB: { fontSize: 16.5, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 16px', maxWidth: 520 },
  trustB: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
};
